import { useState, useEffect, useRef } from 'react';
import { BG_CONTENT, TEXT_MUTED, BORDER_DEFAULT, TEXT_HEADING, TEXT_DEFAULT, BG_SURFACE, SURFACE_WHITE, FONT_LABEL, FONT_TINY } from '../../theme';

const inputStyle = {
  ...FONT_LABEL,
  width: '100%', padding: '0.55rem 0.7rem',
  border: `1px solid ${BORDER_DEFAULT}`,
  borderRadius: 6, background: BG_SURFACE,
  color: TEXT_HEADING, outline: 'none', boxSizing: 'border-box',
};

export default function EntitySelector({ items, selectedIds, onAdd, onRemove, placeholder, disabled, chipBg, chipColor }) {
  const [input, setInput] = useState('');
  const [open, setOpen]   = useState(false);
  const [hovered, setHovered] = useState(null);
  const cRef = useRef(null);

  useEffect(() => {
    const h = (e) => { if (cRef.current && !cRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', h);
    return () => document.removeEventListener('mousedown', h);
  }, []);

  const available = items.filter((i) =>
    !selectedIds.includes(i.id) && i.label.toLowerCase().includes(input.toLowerCase())
  );
  const handleSelect = (item) => { onAdd(item.id); setInput(''); };

  return (
    <div ref={cRef} style={{ position: 'relative' }}>
      {selectedIds.length > 0 && (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.3rem', marginBottom: '0.4rem' }}>
          {selectedIds.map((id) => {
            const it = items.find((i) => i.id === id);
            return (
              <span key={id} style={{
                ...FONT_TINY,
                display: 'inline-flex', alignItems: 'center', gap: '0.2rem',
                background: chipBg || '#e0e7ef', color: chipColor || TEXT_DEFAULT, borderRadius: 4,
                padding: '0.12rem 0.35rem 0.12rem 0.45rem',
              }}>
                {it ? it.label : id}
                <button type="button" onClick={() => onRemove(id)}
                  style={{ background: 'none', border: 'none', cursor: 'pointer', color: TEXT_MUTED, padding: 0, fontSize: '0.85rem', lineHeight: 1, display: 'flex', alignItems: 'center' }}
                >×</button>
              </span>
            );
          })}
        </div>
      )}
      <input
        value={input}
        onChange={(e) => { setInput(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        placeholder={placeholder}
        disabled={disabled}
        style={inputStyle}
      />
      {open && available.length > 0 && (
        <div style={{
          position: 'absolute', top: '100%', left: 0, right: 0,
          background: SURFACE_WHITE, border: `1px solid ${BORDER_DEFAULT}`,
          borderRadius: 6, boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          zIndex: 200, maxHeight: 260, overflowY: 'auto', marginTop: 2,
        }}>
          {available.map((item) => (
            <button key={item.id} type="button"
              onMouseDown={(e) => { e.preventDefault(); handleSelect(item); }}
              onMouseEnter={() => setHovered(item.id)}
              onMouseLeave={() => setHovered(null)}
              style={{
                ...FONT_LABEL,
                display: 'block', width: '100%', textAlign: 'left',
                border: 'none', cursor: 'pointer', padding: '0.4rem 0.65rem',
                color: TEXT_DEFAULT,
                background: hovered === item.id ? BG_CONTENT : 'transparent',
              }}
            >{item.label}</button>
          ))}
        </div>
      )}
    </div>
  );
}
